import React from "react";
import { Tab } from "semantic-ui-react";

export default function SoftPhone() {
	return <Tab.Pane style={{ height: "100%" }}>SoftPhone</Tab.Pane>;
}
